import { ReactElement, ReactNode } from 'react'
import { CenterFocusStrong as CenterFocusStrongIcon } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  children?: ReactNode
}

const FocusButton = ({ children = 'Auf Elemente fokussieren', ...props }: Props): ReactElement => {
  return (
    <Button size="small" startIcon={<CenterFocusStrongIcon fontSize="small" />} {...props}>
      {children}
    </Button>
  )
}

export default FocusButton
